import { render, staticRenderFns } from "./gj.vue?vue&type=template&id=642732ee&scoped=true&"
import script from "./gj.vue?vue&type=script&lang=js&"
export * from "./gj.vue?vue&type=script&lang=js&"
import style0 from "./gj.vue?vue&type=style&index=0&id=642732ee&lang=less&scoped=true&"
import style1 from "./gj.vue?vue&type=style&index=1&id=642732ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642732ee",
  null
  
)

export default component.exports